/**
 * 全局状态
 */

import { timeout } from "@/utils/util.js";
const download = {
  namespaced: true,
  state: {
    downAmount: 0,
    downCount: [],
  },
  mutations: {
    updateDownAmount(state, count) {
      //  数字处理
      if (count > 99) {
        count = "99+";
      }

      state.downAmount = count;
    },
    async updateDownCount(state, data) {
      if (data) {
        await timeout(80);
        state.downCount.push(data);
      } else {
        state.downCount = [];
      }
    },
  },
};
export default download;
